import axios from '../axiosCall'
import Urls from "../endpoints";
import { IRequestkeyhan, IResponseDownloadKeyhanLog, IResponseKeyhan } from '../resultAPI/keyhanRequest';

export const getKeyhanRequest = (id: IRequestkeyhan) => {
    return axios.get<IResponseKeyhan>(Urls.GetKeyhanRequest(id))
}

export const downloadKeyhanRequest = (id: IRequestkeyhan) => {
    return axios.get<IResponseDownloadKeyhanLog>(Urls.DownloadKeyhanRequest(id),{responseType: "blob"})
}
